import { gateway } from "../../../../gateway";
import { AxiosResponse } from "axios";
import { IInvoice } from "../../create/interfaces/invoice.interfaces";

export type InvoiceListPaymentStatusParam = "all" | "paid" | "pending";
export type InvoiceListKindParam = "all" | "deposit" | "standard";

export interface GetInvoicesParams {
  page?: number;
  pagesize?: number;
  order?: string;
  ordertype?: string;
  filterBy?: string;
  filterValue?: string;
  clientUid?: string;
  createdFrom?: string;
  createdTo?: string;
  paymentStatus?: InvoiceListPaymentStatusParam;
  invoiceKind?: InvoiceListKindParam;
}

export interface InvoicesListResponse {
  items: IInvoice[];
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export const getInvoices = async (params: GetInvoicesParams = {}): Promise<InvoicesListResponse> => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append("page", params.page.toString());
  if (params.pagesize) queryParams.append("pagesize", params.pagesize.toString());
  if (params.order) queryParams.append("order", params.order);
  if (params.ordertype) queryParams.append("ordertype", params.ordertype);
  if (params.filterBy) queryParams.append("filterBy", params.filterBy);
  if (params.filterValue) queryParams.append("filterValue", params.filterValue);
  if (params.clientUid) queryParams.append("clientUid", params.clientUid);
  if (params.createdFrom) queryParams.append("createdFrom", params.createdFrom);
  if (params.createdTo) queryParams.append("createdTo", params.createdTo);
  if (params.paymentStatus && params.paymentStatus !== "all") {
    queryParams.append("paymentStatus", params.paymentStatus);
  }
  if (params.invoiceKind && params.invoiceKind !== "all") {
    queryParams.append("invoiceKind", params.invoiceKind);
  }

  const response = await gateway.get<AxiosResponse<InvoicesListResponse>>(
    `/invoices/list?${queryParams.toString()}`
  );
  
  return response.data.data;
};
